<template lang="pug">
collapse-component.conteudo(title='Filtrar processos')
  .linha(style="align-items: center")
    .coluna-3
      text-input-component(v-model='filtro.car', label='Número de registro no CAR')
    .coluna-3
      text-input-component(v-model='filtro.nomeImovel', label='Nome do imóvel')
    .coluna-3(style="margin-top: -10px", v-if='isMonitoramentoEnviado')
      select-filter-component(
        ref='selectTemporecomposicao'
        :list="opcoesTempoRecomposicao"
        v-model="filtro.temporecomposicao"
        fieldLabel="Tempo de recomposição"
        label="label"
        chave="value"
        placeholder="Selecione"
        :clearable='false'
        :filterable="true"
      )

    .coluna-2(style="margin-top: -10px", v-if='isMonitoramentoEnviado')
      select-filter-component(
        style="width: 150px; padding: 4px 0px"
        :list="nomeArea"
        v-model="filtro.nomedaArea"
        label="label"
        chave="value"
        fieldLabel="Nome da Área"
        placeholder="Selecione"
        :filterable="false"
      )
  .linha(style="align-items: flex-start")
    .coluna-3
      text-input-component(v-model="cpfCnpjFormatado" @input="onCpfCnpjInput" label='CPF/CNPJ')
    .coluna-3
      date-picker-component(v-model='filtro.dataEnvioDe', @change="validarDatas('dataEnvioDe')", :label='`Data Inicial ${labelCampoData}`')
    .coluna-3
      date-picker-component(:key="dataEnvioAteKey" v-model='filtro.dataEnvioAte', @change="validarDatas('dataEnvioAte')", :label='`Data Final ${labelCampoData}`')
  .linha(style="align-items: center; gap: 16px;", v-if='isMonitoramentoEnviado')
    .coluna-4
      select-filter-component(
        :list="nivelMonitoramento"
        v-model="filtro.nivelMoni"
        label="label"
        chave="value"
        fieldLabel="Nível de adequação do monitoramento"
        placeholder="Selecione"
        :filterable="false"
      )
    .coluna-4
      select-filter-component(
        :list="statusMonitoramento"
        v-model="filtro.statusMoni"
        label="label"
        chave="value"
        fieldLabel="Status do monitoramento"
        placeholder="Selecione"
        :filterable="false"
      )
    .coluna-3
      select-filter-component(
        style="width: 250px;"
        :list="avaliacaoGeral"
        v-model="filtro.avaliacaoGe"
        label="label"
        chave="value"
        fieldLabel="Avaliação geral"
        placeholder="Selecione"
        :filterable="false"
      )
    .coluna-3
        select-filter-component(
            style="width: 250px;"
            :list="statusValidacao"
            v-model="filtro.statusValidacao"
            label="label"
            chave="value"
            fieldLabel="Situação da validação"
            placeholder="Selecione"
            :filterable="false"
        )

  .linha(style="align-items: flex-start")
    .coluna-2
      text-input-component(:disabled='true', v-model='filtro.uf', label='UF')
    .coluna-2
      select-filter-component(
        ref='selectRegional'
        v-model='filtro.regional'
        :list='regionais'
        label='nome'
        fieldLabel='Regional:'
        placeholder='Selecione'
        :filterable='true'
        @input='selecionarRegional'
      )
    .coluna-2
      select-filter-component(
        ref='selectMunicipio'
        :list='municipios'
        v-model="filtro.municipio"
        label='nome'
        fieldLabel='Município:'
        placeholder='Selecione'
        :filterable='true'
        @input='selecionarMunicipio'
      )
    .coluna-2(v-if='!isMonitoramentoEnviado')
      select-filter-component(
        ref='selectStatusSolicitacao'
        :list='statusSolicitacao'
        v-model="filtro.condicao"
        label='label'
        chave='value'
        fieldLabel='Status da solicitação:'
        placeholder='Selecione'
      )

  .linha.justify-end
    .coluna-1
      button-component(
        label='Limpar',
        icon='mdi-trash-can',
        background-color='#ddd',
        color='#666',
        @click.native='limpar'
      )
    .coluna-1
      button-component(label='Pesquisar', icon='mdi-magnify', @click.native='pesquisar')
</template>
<script>
import SelectFilterComponent from '@/views/monitoramento/components/SelectFilterComponent.vue';

export default {
    name: 'FiltroComponent',
    components: {
        SelectFilterComponent,
    },
    props: {
        municipios: {
            type: Array,
            required: true,
        },
        regionais: {
            type: Array,
            required: true,
        },
        abaAtiva: {
            type: String,
            required: true
        },
        labelCampoData: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            filtro: {
                car: '',
                nomeImovel: '',
                cpfCnpjProprietario: '',
                dataEnvioDe: '',
                dataEnvioAte: '',
                municipio: '',
                regional: '',
                temporecomposicao: '',
                nomedaArea: '',
                nivelMoni: '',
                statusMoni: '',
                avaliacaoGe: '',
                statusValidacao: '',
                condicao: '',
                uf: 'SP',
                pagina: 1,
                quantidadePagina: 10,
            },
            dataEnvioAteKey: 0,
            opcoesTempoRecomposicao: [
                { label: '1 ano', value: '1' },
                { label: '2 anos', value: '2' },
                { label: '3 anos', value: '3' },
                { label: '4 anos', value: '4' },
                { label: '5 anos', value: '5' },
                { label: '6 anos', value: '6' },
                { label: '7 anos', value: '7' },
                { label: '8 anos', value: '8' },
                { label: '9 anos', value: '9' },
                { label: '10 anos', value: '10' },
            ],

            nomeArea: [
                { label: 'Todos', value: '' },
                { label: 'APP', value: 'APP' },
                { label: 'RL', value: 'RL' },
                { label: 'AUR', value: 'AUR' },
            ],

            nivelMonitoramento: [
                { label: '0°', value: '0' },
                { label: '1°', value: '1' },
                { label: '2°', value: '2' },
                { label: '3°', value: '3' },
                { label: '4°', value: '4' },
                { label: '5°', value: '5' },
                { label: '6°', value: '6' },
            ],

            statusMonitoramento: [
                { label: 'Aguardando monitoramento', value: 'AGUARDANDO_MONITORAMENTO' },
                { label: 'Pendente de envio', value: 'PENDENTE_DE_ENVIO' },
                { label: 'Finalizado', value: 'FINALIZADO' },
            ],

            avaliacaoGeral: [
                { label: 'Regular-Adequado', value: 'ADEQUADO' },
                { label: 'Regular-Minimo', value: 'MINIMO' },
                { label: 'Irregular-Crítico', value: 'CRITICO' },
            ],

            statusValidacao: [
                { label: 'Em monitoramento', value: null },
                { label: 'Aguardando validação', value: 'PENDENTE_VALIDACAO' },
                { label: 'Monitoramento encerrado', value: 'APROVADO' },
                { label: 'Reprovado', value: 'REPROVADO' },
            ],

            statusSolicitacao: [
                { label: 'Aguardando análise', value: 'AGUARDANDO_ANALISE' },
                { label: 'Aprovada', value: 'APROVADO' },
                { label: 'Reprovada', value: 'REPROVADO' },
            ],
        };
    },
    watch: {
        'filtro.dataEnvioDe'() {
            this.validarDatas('dataEnvioDe');
        },
        'filtro.dataEnvioAte'() {
            this.validarDatas('dataEnvioAte');
        },
    },

    computed: {
        cpfCnpjFormatado: {
            get() {
                return this.formatarCpfCnpj(this.filtro.cpfCnpjProprietario);
            },
            set(valor) {
                // Remove tudo que não é número e corta no máximo 14 caracteres
                const numeros = valor.replace(/\D/g, '').slice(0, 14);
                this.filtro.cpfCnpjProprietario = numeros;
            },
        },
        isMonitoramentoEnviado() {
            return this.abaAtiva === 'monitoramentoEnviado';
        }
    },
    methods: {
        onCpfCnpjInput(event) {
            let valor = event.target.value.replace(/\D/g, '');
            if (valor.length > 14) {
                valor = valor.slice(0, 14);
            }
            this.filtro.cpfCnpjProprietario = valor;
        },
        formatarCpfCnpj(valor) {
            const numeros = valor.replace(/\D/g, '').slice(0, 14); // limita máximo 14 dígitos

            if (numeros.length <= 11) {
                // Formata CPF (até 11 dígitos)
                return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, (match, g1, g2, g3, g4) => {
                    let res = g1 || '';
                    if (g2) res += '.' + g2;
                    if (g3) res += '.' + g3;
                    if (g4) res += '-' + g4;
                    return res;
                });
            } else {
                // Formata CNPJ (mais que 11 dígitos, até 14)
                return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, (match, g1, g2, g3, g4, g5) => {
                    let res = g1 || '';
                    if (g2) res += '.' + g2;
                    if (g3) res += '.' + g3;
                    if (g4) res += '/' + g4;
                    if (g5) res += '-' + g5;
                    return res;
                });
            }
        },

        validarDatas(campoAlterado) {
            const { dataEnvioDe, dataEnvioAte } = this.filtro;

            const inicio = this.converterParaData(dataEnvioDe);
            const fim = this.converterParaData(dataEnvioAte);

            if (inicio && fim && inicio > fim) {
                this.$toast({
                    showClose: true,
                    message: 'A Data Inicial não pode ser maior que a Data Final',
                    type: 'error',
                });
                if (campoAlterado === 'dataEnvioDe') {
                    this.filtro.dataEnvioDe = '';
                } else {
                    this.filtro.dataEnvioAte = '';
                    this.dataEnvioAteKey += 1;
                }
            }
        },
        converterParaData(data) {
            if (!data) return null;

            if (data instanceof Date) {
                if (isNaN(data)) return null;
                return data;
            }

            if (typeof data === 'string') {
                if (data.includes('-')) {
                    const partes = data.split('-');
                    if (partes.length !== 3) return null;
                    const [ano, mes, dia] = partes.map(Number);
                    if (!ano || !mes || !dia) return null;
                    if (String(ano).length < 4) return null;
                    const dataObj = new Date(ano, mes - 1, dia);
                    if (dataObj.getFullYear() !== ano || dataObj.getMonth() !== mes - 1 || dataObj.getDate() !== dia)
                        return null;
                    return dataObj;
                }
                if (data.includes('/')) {
                    const partes = data.split('/');
                    if (partes.length !== 3) return null;
                    const [dia, mes, ano] = partes.map(Number);
                    if (!ano || !mes || !dia) return null;
                    if (String(ano).length < 4) return null;
                    const dataObj = new Date(ano, mes - 1, dia);
                    if (dataObj.getFullYear() !== ano || dataObj.getMonth() !== mes - 1 || dataObj.getDate() !== dia)
                        return null;
                    return dataObj;
                }
            }

            return null;
        },

        selecionarTempoRecomposicao(valor) {
            this.filtro.temporecomposicao = valor;
        },

        selecionarNomeArea(valor) {
            this.filtro.nomedaArea = valor;
        },

        selecionarNivelMoni(valor) {
            this.filtro.nivelMoni = valor;
        },

        selecionarStatusMoni(valor) {
            this.filtro.statusMoni = valor;
        },

        selecionarAvaliacaoGe(valor) {
            this.filtro.avaliacaoGe = valor;
        },

        selecionarMunicipio(municipio) {
            this.filtro.municipio = municipio;
            this.$emit('municipio:alterado', municipio);
        },

        selecionarRegional(regional) {
            this.filtro.regional = regional;
            this.$emit('regional:alterada', regional);
        },

        limpar() {
            // Resetar todos os filtros
            this.filtro = {
                car: '',
                nomeImovel: '',
                cpfCnpjProprietario: '',
                dataEnvioDe: '',
                dataEnvioAte: '',
                municipio: '',
                regional: '',
                temporecomposicao: '',
                nomedaArea: '',
                nivelMoni: '',
                statusMoni: '',
                avaliacaoGe: '',
                statusValidacao: '',
                condicao: '',
                pagina: 1,
                quantidadePagina: 10,
                uf: 'SP',
            };

            this.$emit('filtro:limpar', this.filtro);
        },

        pesquisar() {
            this.$emit('filtro:pesquisar', this.filtro);
        },
    },
};
</script>
